var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"go-logo tw-block tw-h-auto tw-mx-auto tw-mb-6",attrs:{"src":_vm.logo}})
}
var staticRenderFns = []

export { render, staticRenderFns }